import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-mega-card',
  templateUrl: './mega-card.component.html',
  styleUrls: ['./mega-card.component.css']
})
export class MegaCardComponent implements OnInit {


  @Input() cardType: 'free' | 'premium' | 'locked' | 'banner' | 'promo' = 'free'; // Card Type
  @Input() title: string = ''; // Card Title
  @Input() description: string = ''; // Card Description
  @Input() imageUrl: string = ''; // Background/Image
  @Input() status: 'paid' | 'pending' | 'failed' = 'pending'; // Payment Status
  @Input() ctaText: string = 'View'; // Button Text
  @Input() badgeText: string = ''; // Badge Text (e.g., "Premium", "Free")

  @Output() ctaClicked = new EventEmitter<void>(); // Emit event when CTA is clicked

  constructor() { }


  onCtaClick() {
    this.ctaClicked.emit();
  }

  ngOnInit(): void {
  }
  

}
